import { CircularProgress, EmptyState, Link, Stack, Tag } from '@all-manager/design-system-v2';
import FullPageLayout from "../../../layout/FullPageLayout/FullPageLayout";
import ProviderAddActions from "../components/ProviderAddActions/ProviderAddActions";
import ProviderDetails from "../components/ProviderDetails/ProviderDetails";
import ProviderMenuAction from "../components/ProviderMenuAction/ProviderMenuAction";
import ProviderTagPicker from "../components/ProviderTagPicker/ProviderTagPicker";
import { ProviderTag } from '../types';
import { useProviderPage } from "./useProviderPage";

export default function ProviderPage() {
  const hook = useProviderPage();

  const hasTags = !!(hook.provider?.tags && hook.provider.tags.length > 0);
  const canShowTagsElement = hasTags || (hook.isAdmin && !!hook.provider);

  const tagsElement = canShowTagsElement ? (
    <Stack direction="row" spacing={1} wrap="wrap" alignItems="center">
      {hook.provider?.tags?.map((tag: ProviderTag) => (
        <Tag key={tag.id} label={tag.name} color="default" variantIcon="label" />
      ))}
      {hook.isAdmin && hook.provider ? (
        <ProviderTagPicker
          selectedTags={hook.provider.tags ?? []}
          onChange={hook.handleTagsChange}
          showSelectedTagsInline={false}
          triggerButtonText={hasTags ? 'Modifier les tags' : 'Ajouter des tags'}
        />
      ) : null}
    </Stack>
  ) : null;

  const subtitle = hook.provider?.description || hook.address ? (
    <span>
      {hook.provider?.description}
      {hook.provider?.description && hook.address ? ' · ' : null}
      {hook.address && hook.mapsUrl ? (
        <Link
          href={hook.mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          color="textSecondary"
          underline="hover"
        >
          {hook.address}
        </Link>
      ) : null}
    </span>
  ) : undefined;

  return (
    <FullPageLayout
      htmlTitle={hook.provider?.name ?? 'Prestataire'}
      title={hook.provider?.name ?? ''}
      status={
        hook.provider?.hasActiveContract ? (
          <Tag label="Sous contrat" color="done" variantIcon="state" />
        ) : null
      }
      backLink={hook.backLink}
      subtitle={subtitle}
      action={hook.provider && hook.isAdmin ? (
        <Stack direction="row" spacing={1} alignItems="center">
          <ProviderAddActions providerId={hook.provider.id} />
          <ProviderMenuAction
            provider={hook.provider}
            size="medium"
            afterDeletionSuccess={hook.handleDeletionSuccess}
          />
        </Stack>
      ) : undefined}
    >
      {hook.isLoading ? (
        <Stack alignItems="center">
          <CircularProgress aria-label="Chargement du prestataire" />
        </Stack>
      ) : hook.provider ? (
        <Stack spacing={2}>
          {tagsElement}
          <ProviderDetails provider={hook.provider} />
        </Stack>
      ) : (
        <EmptyState
          title="Prestataire introuvable"
          subtitle="Ce prestataire a peut-être été supprimé."
        />
      )}
    </FullPageLayout>
  );
}
